"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var basicline_1 = require("../basicline");
function CompareLine(props) {
    var color = props.color;
    var colorFormatter = function (_, i) {
        if (i === 0)
            return "#2d70f6";
        return "#B8D6FF";
    };
    var propsCopy = Object.assign({
        size: 2,
    }, props, {
        color: { key: color, colors: colorFormatter },
    });
    return react_1.default.createElement(basicline_1.BasicLine, tslib_1.__assign({}, propsCopy));
}
exports.CompareLine = CompareLine;
//# sourceMappingURL=CompareLine.js.map